<template>
  <v-app-bar color="primary">
    <v-icon class="ml-3 ts-icon">tsyl:technosylva</v-icon>
    <v-toolbar-title class="ts-font">my technosylva</v-toolbar-title>
    <div class="mr-4">
      <OrganizationSwitcher
        @error="(msg) => addNotification({ title: t('general.error'), body: msg, type: 'error' })"
      />
    </div>
    <!-- @vue-expect-error TODO: Define models -->
    <ZDaisukeUserMenu class="mr-3" :user="user" :menu="menu">
      <template #lowerMenu>
        <v-row>
          <v-col cols="12">
            <v-btn block variant="outlined" to="/account">My Account</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn block variant="outlined" @click="doLogout">Logout</v-btn>
          </v-col>
        </v-row>
      </template>
    </ZDaisukeUserMenu>
  </v-app-bar>
</template>

<script setup lang="ts">
import { logout, OrganizationSwitcher } from '@tsyl/daisuke-auth-plugin'
import type { DaisukeMenu } from '@tsyl/zapan2/lib/types/ZDaisukeUserMenu'
import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'
import { useNotifications } from '@tsyl/zapan2'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'

const { t } = useI18n()
const { addNotification } = useNotifications()
const daisuke = daisukeAuth0Store()
const { user } = storeToRefs(daisuke)

const menu = [
  {
    text: 'Knowledge base/user guide',
    icon: 'mdi-head-question',
    href: 'https://help.wildfireanalyst.com/wfae-web/',
  },
] as DaisukeMenu[]

//TODO see whats wrong with logout function
function doLogout() {
  logout()
}
</script>

<style scoped>
.ts-icon {
  font-size: 38px;
}
</style>
